// Sugalarm — /api/predictions wrappers (cycle 7 backend, cycle 10 UI).

import { request } from "../lib/apiClient";
import type {
  ApiResult,
  Prediction,
  PredictionStatsResponse,
} from "../lib/types";

export interface PredictionListResponse {
  count: number;
  predictions: Prediction[];
}

export interface ListOpts {
  hours?: number;
  limit?: number;
  unacknowledgedOnly?: boolean;
  pendingOnly?: boolean;
}

export function list(opts: ListOpts = {}): Promise<ApiResult<PredictionListResponse>> {
  const params = new URLSearchParams();
  params.set("hours", String(opts.hours ?? 24));
  params.set("limit", String(opts.limit ?? 200));
  if (opts.unacknowledgedOnly) params.set("unacknowledged_only", "true");
  if (opts.pendingOnly) params.set("pending_only", "true");
  return request<PredictionListResponse>(`/api/predictions?${params.toString()}`);
}

export function acknowledge(id: string): Promise<ApiResult<Prediction>> {
  return request<Prediction>(`/api/predictions/${id}/acknowledge`, { method: "POST" });
}

export function acknowledgeAll(): Promise<ApiResult<{ acknowledged: number }>> {
  return request<{ acknowledged: number }>("/api/predictions/acknowledge_all", {
    method: "POST",
  });
}

export function stats(days = 30): Promise<ApiResult<PredictionStatsResponse>> {
  return request<PredictionStatsResponse>(`/api/predictions/stats?days=${days}`);
}
